import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  PDFDownloadLink,
  Image,
  Link
} from "@react-pdf/renderer";
import ENVIRONMENT_VAR from "@/src-refactor/modules/shared/model/const/env/env.const";
import { useLoggedUser } from "@/shared/store/auth";
import { useRealEstateDetailContext } from "../../context/realestate-details.context";
import PDFAgentProfile from "./PDFAgentProfile";
import PDFImageGrid from "./PDFImagesGrid";
import PriceLabel from "./PDFPriceLabel";
import PDFGeneralInformation from "./PDFGeneralInformation";
import QRCodeToPNG from "./PDFQRCode";
import LocationIcon from "@/assets/icons/location-icon1.png";
import CarIcon from "@/assets/icons/characteristics/carro.png";
import WaterIcon from "@/assets/icons/characteristics/agua.png";
import PumpIcon from "@/assets/icons/characteristics/pumps.png";
import BathIcon from "@/assets/icons/characteristics/bath.png";
import BedIcon from "@/assets/icons/characteristics/bed.png";
import MeasureIcon from "@/assets/icons/characteristics/medida.png";
import HouseIcon from "@/assets/icons/characteristics/casa2.png";
import PropertyCharacteristicsPDF from "./PDFPropertyCharacteristics";
import { getTruncatedDescription } from "@/src-refactor/modules/shared/helpers/truncate-multiple";
import PDFBlueLabel from "./PDFBlueLabel";
import PropertyCharacteristicsIconsPDF from "./PDFCharacteristics";
import ArrowIcon from "@/assets/icons/download-svgrepo-com.png";
import { memo, useMemo, useCallback, useEffect, useState } from "react";
import MxTypography from "@rf-l1/MxTypography";
import { Grid } from "@mui/material";
import PDFFloorsTotalIcon from "./PDFFloorsTotalIcon";
import usePropertyBrochurePdf from "@rf/property/module/hooks/usePropertyBrochurePdf";

// const prepareImagesForPDF = async (imageUrls: string[]): Promise<string[]> => {
//   return Promise.all(
//     imageUrls.map(async url => {
//       return new Promise<string>((resolve, reject) => {
//         const img = new window.Image();
//         img.crossOrigin = "anonymous";

//         img.onload = () => {
//           // Crear canvas para convertir a JPG
//           const canvas = document.createElement("canvas");
//           canvas.width = img.width;
//           canvas.height = img.height;

//           // Dibujar imagen en el canvas
//           const ctx = canvas.getContext("2d");
//           ctx?.drawImage(img, 0, 0);

//           // Convertir a JPG con calidad 0.9
//           resolve(canvas.toDataURL("image/jpeg", 0.9));
//         };

//         img.onerror = () => {
//           console.error(`Error loading image: ${url}`);
//           reject(new Error(`Failed to load image: ${url}`));
//         };

//         img.src = url;
//       });
//     })
//   );
// };

// const usePrepareImagesForPDF = (images: string[]) => {
//   const [imagesPDF, setImagesPDF] = useState<string[]>([]);
//   const [imgLoading, setImgLoading] = useState(false);

//   const prepareImages = useCallback(async () => {
//     const imagesURL = images.map(
//       x => `${ENVIRONMENT_VAR.API_URL}/v2/download-image?url=${x}`
//     );
//     setImgLoading(true);
//     const imagesPDF = await prepareImagesForPDF(imagesURL);
//     setImagesPDF(imagesPDF);
//     setImgLoading(false);
//   }, [images]);

//   useEffect(() => {
//     prepareImages();
//   }, [images]);

//   return {
//     imagesPDF,
//     imgLoading
//   };
// };

const PDFPropertyMain = () => {
  const { userLogged } = useLoggedUser();
  const {
    PROPERTY_DETAIL: { principalData, agents, brochure }
  } = useRealEstateDetailContext();
  const { generateBrochure } = usePropertyBrochurePdf();
  const handleDownload = () => {
    generateBrochure(brochure);
  };

  return (
    <a
      target="_blank"
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: 9,
        marginLeft: 3,
        padding: "4px 0px",
        fontSize: 12,
        cursor: "pointer"
      }}
      onClick={handleDownload}
    >
      <img src={ArrowIcon} style={{ width: "14px", height: "14px" }} />
      Descargar PDF
    </a>
  );
};

export default memo(PDFPropertyMain);
